import { OrderDetails } from '@nemuru-eng/js-api-client';

import { OrderAction } from '../../../types/OrderAction';

export const calculateMaxAmounts = (orderDetails: OrderDetails, actions: OrderAction[]) => {
  let maxToCapture, maxToRefund;
  if (actions && orderDetails) {
    maxToCapture = orderDetails.totalOrderAmount - orderDetails.totalCapturedAmount;
    maxToRefund = orderDetails.totalCapturedAmount - orderDetails.totalRefundedAmount;
  }
  return { maxToCapture, maxToRefund };
};
